import getMagicLinkValues from "src/utils/getMagicLinkValues";
import fillStore from "src/store";
import { getDeal } from "src/store/dataService/actions/deal";
import { getLocalDealState, rememberDealFromMagicLink } from "src/utils/localStorage";
import toggleOS from "src/sdk/toggleOS";
import { initialState as onlineShopperInitialState } from "src/store/reducers/onlineShopper";
import { getPageType } from "src/utils/autoNationTag";
import handleHostTrackingData, { ASYNC_TRACKERS, STATIC_TRACKING_VALUES } from "src/utils/handleHostTrackingData";
import { initBugsnag } from "src/utils/logger";
import { loadLocaleData } from "src/utils/updateLanguage";
import render from "src/utils/render";

const setDrawerState = (initialEntries: [string] | undefined) =>
    initialEntries && initialEntries.includes("/my-garage/message-center") ? { isDrawerOpen: true } : null;

const initialize = async (accountSlug: string, env: string, srpLink: string) => {
    // Lazy load locale data (translations, moment, date-fns)
    await loadLocaleData();

    // Look for any magic link values, save to local storage if present
    const magicLinkValues = getMagicLinkValues();

    // Initialize the state: defaults < local storage < magic link
    const { uuid, isAuthed, garageCreated, isDrawerOpen = false } = {
        uuid: undefined,
        isAuthed: false,
        garageCreated: false,
        ...getLocalDealState({ slug: accountSlug, env }),
        ...(magicLinkValues.uuid && {
            uuid: magicLinkValues.uuid,
            garageCreated: true,
            isAuthed: true,
        }),
        ...setDrawerState(magicLinkValues.initialEntries),
    };

    // Setup redux store
    const store = fillStore({
        onlineShopper: {
            ...onlineShopperInitialState,
            env,
            srpLink,
            referer: window.location.href,
            pageType: getPageType(),
            isAuthed,
            garageCreated,
            isDrawerOpen,
        },
        // @ts-ignore
        account: {
            loading: true,
            slug: accountSlug,
        },
        deal: {
            uuid,
        },
    });

    // Initialize Bugsnag
    const bugsnagClient = initBugsnag(process.env.APP_VERSION!, store);

    // Render the app using a helper that will handle hot reloading
    render({ store, ErrorBoundary: bugsnagClient, initialEntries: magicLinkValues.initialEntries });

    if (uuid) {
        // Fetch existing deal and patch updated tracking values
        await store.dispatch(getDeal(uuid));
    }

    // Patch updated tracking values, retrying to catch any that haven't loaded yet
    handleHostTrackingData(store.dispatch, () => store.getState().deal.uuid, ASYNC_TRACKERS, STATIC_TRACKING_VALUES);

    // If any magic links were present, toggle open
    if (magicLinkValues.uuid || magicLinkValues.vin) {
        // If the OnlineShopper_UUID magic link was present, remember deal in localstorage
        if (magicLinkValues.uuid) {
            rememberDealFromMagicLink(accountSlug, env, magicLinkValues.uuid);
        }
        await toggleOS(store, magicLinkValues.vin);
    }

    // Return the initialized Redux store so our other window.OnlineShopper interface methods have access to it
    return store;
};

export default initialize;
